// removed by extract-text-webpack-plugin
module.exports = {"modal__overlay":"modal__overlay-bedc16","modal__overlay_show":"modal__overlay_show-7a723a","modal__dialog":"modal__dialog-0d7c06","modal__dialog_show":"modal__dialog_show-2b10f5","modal__content":"modal__content-075d39","modal__header":"modal__header-dc770c","modal__title":"modal__title-814cd5","modal__close":"modal__close-8253db","modal__actions":"modal__actions-c15b3c","modal__actions_button":"modal__actions_button-085c30","modal__body":"modal__body-0d70f1","modal__scroll":"modal__scroll-38ad79"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/modal-dialog/style.pcss
// module id = ./src/blocks/modal-dialog/style.pcss
// module chunks = 0